import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import IconButton from '@zenbusiness/zui/IconButton';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledCard = superstyled({
  name: 'OrderHistoryCard',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    marginBlock: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginBlock: theme.spacing(3),
    },
  }),
});

export const StyledTableContainer = superstyled({
  name: 'OrderHistoryTableContainer',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    overflowX: 'auto',
    [theme.breakpoints.down('md')]: {
      marginInline: theme.spacing(-2),
    },
  }),
});

export const StyledTable = superstyled({
  name: 'OrderHistoryTable',
  slot: 'Root',
  tag: 'table',
  styles: ({ theme }) => ({
    width: '100%',
    borderCollapse: 'collapse',
    '& thead': {
      backgroundColor: theme.palette.grey[50],
      borderBottom: `2px solid ${theme.palette.divider}`,
    },
    '& th': {
      padding: theme.spacing(3, 0, 3, 4),
      textAlign: 'left',
      fontWeight: 600,
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
      minWidth: '250px',
      '&[data-status-column]': {
        minWidth: '225px',
      },
    },
    '& td': {
      padding: theme.spacing(3, 0, 3, 2.25),
      borderBottom: `1px solid ${theme.palette.divider}`,
      verticalAlign: 'top',
    },
    '& tbody tr': {
      transition: 'background-color 0.2s',
    },
  }),
});

export const TableBox = superstyled({
  name: 'OrderHistoryTableBox',
  slot: 'Root',
  tag: Box,
  styles: () => ({
    display: 'flex',
    alignItems: 'center',
    padding: '24px 0 24px 18px',
  }),
});

export const IncludedBox = superstyled({
  name: 'OrderHistoryIncludedBox',
  slot: 'Root',
  tag: Box,
  styles: () => ({
    padding: '5px 0 5px 18px',
    whiteSpace: 'nowrap',
  }),
});

export const OrderStatusDot = superstyled({
  name: 'OrderHistoryStatusDot',
  slot: 'Root',
  tag: 'div',
  propsNeeded: ['status'],
  styles: ({ theme, status }) => {
    const statusColors = {
      inactive: theme.palette.grey[400],
      pending: theme.palette.warning.main,
      'order received': theme.palette.info.main,
      active: theme.palette.success.main,
      complete: theme.palette.success.dark,
      canceled: theme.palette.error.main,
    };

    return {
      width: '10px',
      height: '10px',
      borderRadius: '5px',
      marginRight: '10px',
      backgroundColor: statusColors[status] || theme.palette.grey[400],
    };
  },
});

export const StyledIconButton = superstyled({
  name: 'OrderHistoryIconButton',
  slot: 'Root',
  tag: IconButton,
  styles: () => ({
    padding: 0,
    marginLeft: '2rem',
  }),
});

export const StyledNavigateButton = superstyled({
  name: 'OrderHistoryNavigateButton',
  slot: 'Root',
  tag: IconButton,
  styles: ({ theme }) => ({
    color: theme.palette.primary.main,
  }),
});
